import React, { useState, useEffect } from "react";
import BarChart from "./BarChart";
import DataTable from "./DataTable";
import Line from "./Line";
import "./Efficiency.css";

function NavbarComponent(props) {
  const selectedyears = props.selectedyears;
  const airports = props.airports;
  const airportsCodes = props.airports.map((airport) => airport.slice(-3));
  const [activeTab, setActiveTab] = useState(1);
  const [efficiency_data, setEfficiencyData] = useState([]);

  useEffect(() => {
    var url2 = "/api/result_efficiency/";
    fetch(url2, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        years: selectedyears,
        airport_codes: airportsCodes,
      }),
    })
      .then((response) => response.json())
      .then((data2) => {
        var eff = data2.data.data;
        console.log("EFF: ", eff);
        setEfficiencyData(eff);
        console.log("EFFICIENCY DATA: ", efficiency_data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, [selectedyears, airports]); // Update the dependency array

  const handleTabClick = (tabNumber) => {
    setActiveTab(tabNumber);
  };

  let contentComponent;

  console.log("EFFICIENCY DATA2: ", efficiency_data);

  // const dummy_data = [
  //   { Έτος: "2013", Αεροδρόμιο: "AOK", "Τεχνική Αποδοτικότητα": "0.3" },
  //   { Έτος: "2013", Αεροδρόμιο: "AXD", "Τεχνική Αποδοτικότητα": "0.5" },

  //   { Έτος: "2014", Αεροδρόμιο: "AXD", "Τεχνική Αποδοτικότητα": "0.3" },
  //   { Έτος: "2014", Αεροδρόμιο: "AOK", "Τεχνική Αποδοτικότητα": "0.5" },
  //   { Έτος: "2014", Αεροδρόμιο: "ATH", "Τεχνική Αποδοτικότητα": "0.15" },

  //   { Έτος: "2015", Αεροδρόμιο: "AOK", "Τεχνική Αποδοτικότητα": "0.9" },
  //   { Έτος: "2015", Αεροδρόμιο: "AXD", "Τεχνική Αποδοτικότητα": "0.2" },

  //   { Έτος: "2016", Αεροδρόμιο: "ATH", "Τεχνική Αποδοτικότητα": "0.29" },

  //   { Έτος: "2017", Αεροδρόμιο: "AXD", "Τεχνική Αποδοτικότητα": "0.43" },
  //   { Έτος: "2017", Αεροδρόμιο: "AOK", "Τεχνική Αποδοτικότητα": "0.12" },
  //   { Έτος: "2017", Αεροδρόμιο: "ATH", "Τεχνική Αποδοτικότητα": "0.98" },

  //   { Έτος: "2018", Αεροδρόμιο: "ATH", "Τεχνική Αποδοτικότητα": "0.25" },
  //   { Έτος: "2018", Αεροδρόμιο: "AXD", "Τεχνική Αποδοτικότητα": "0.8" },
  // ];

  switch (activeTab) {
    case 1:
      console.log(efficiency_data);
      contentComponent = <BarChart data={efficiency_data} />;
      break;
    case 2:
      contentComponent = <DataTable data={efficiency_data} />;
      break;
    case 3:
      contentComponent = <Line data={efficiency_data} />;
      break;
    default:
      contentComponent = null;
  }

  return (
    <div
      style={{
        marginTop: "100px",
      }}
    >
      {console.log(efficiency_data)}
      <nav>
        <ul className="navbar3">
          <li
            className={activeTab === 1 ? "active" : ""}
            onClick={() => handleTabClick(1)}
          >
            Ραβδόγραμμα
          </li>
          <li
            className={activeTab === 2 ? "active" : ""}
            onClick={() => handleTabClick(2)}
          >
            Πίνακας δεδομένων
          </li>
          <li
            className={activeTab === 3 ? "active" : ""}
            onClick={() => handleTabClick(3)}
          >
            Γραμμή
          </li>
        </ul>
      </nav>
      {contentComponent}
    </div>
  );
}

export default NavbarComponent;
